import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        stack: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: 'xsmall-1.base',
            alignSelf: 'strech',
            width: '100%',
        },
        stackItem: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            cursor: 'pointer',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            gap: 'xxsmall-1',
        },
        textContainer: {
            display: 'flex',
            flexDir: 'row',
            gap: 2,
            color: 'text.default',
            textAlign: 'center',
            textStyle: 'body-small',
            fontWeight: 'normal',
            paddingTop: remCalc(4),
            marginRight: remCalc(10),
        },
        filterLabel: {
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'regular',
        },
        filterHit: {
            color: 'foreground.neutral.subtle',
            textStyle: 'body-small',
            fontWeight: 'regular',
        },
    },
}
